module.exports = __webpack_public_path__ + "static/media/collections-desktop.42004804.svg";